export default {
	getFreeQuantity(group) {
		return group.options.freeQuantity;
	},
	hasSubProductGroups(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.groups.length;
	},
	hasSubProductConfigurations(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.configurations.length;
	},
	getCheckBoxConfigurations(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.configurations.filter(config => config.appearance === "checklist");
	},
	getCheckboxGroups(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.groups.filter(g => g.appearance === "checklist");
	},
	getRadioButtonGroups(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.groups.filter(group => group.appearance === "radiobuttons");
	},
	getAmountGroups(group) {
		const self = this;
		const mainProduct = self.getSubProduct(group);
		return mainProduct.groups.filter(group => group.appearance === "amount");
	},
	getSubProduct(group) {
		const self = this;
		return self.isMainProductGroup(group) ? group.products[0] : null;
	},
	isMainProductGroup(group) {
		return group.appearance === "single";
	},
	getGroupTranslation(group, t) {
		if(group.options && group.options.groupType) {
			const groupType = group.options.groupType;
			return groupType !== "main"
				? t(`shopComponents.gt3.detailsTemplates_steps.groupTitles.${groupType}`)
				: "";
		}
		return t("shopComponents.gt3.detailsTemplates_steps.detailsExtras.selectExtras");
	}
};
